import { render } from "./I18nEditorModal.vue?vue&type=template&id=008fbb50&scoped=true"
import script from "./I18nEditorModal.vue?vue&type=script&lang=js"
export * from "./I18nEditorModal.vue?vue&type=script&lang=js"

import "./I18nEditorModal.vue?vue&type=style&index=0&id=008fbb50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008fbb50"]])

export default __exports__